
    
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class AffidavitOfPersonalService extends Vue {    

    @Prop({required: true})
    instructionsStep!: string;
    
}
